import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Assumes you are using react-router-dom

const DynamicBrowserTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Map your paths to the desired browser tab titles
    const titleMap = {
      '/': 'Home | Congolese Design',
      '/about': 'About Prince | Online CV',
      '/expertise': 'Skills & Toolkit | Technical Mastery',
      '/portfolio': 'Portfolio | Featured Work',
      '/contact': 'Connect | Let’s Collaborate',
    };

    // Fallback to a default title if the path isn't in the map
    const currentTitle = titleMap[location.pathname] || 'Congolese Design';
    
    // This is the magic line that updates the browser tab
    document.title = currentTitle;

  }, [location]); // Re-runs every time the URL path changes

  return null; // This component renders nothing to the DOM
};

export default DynamicBrowserTitle;